<template>
<div class="about-wrapper">
	<h1 class="main-title individual grid-container">About</h1>
	<Carousel :items="result"></Carousel>
</div>
</template>

<script>
import axios from "axios";
import Carousel from './Carousel';
import { API_BASE } from '@/config';

export default {
	name: "test",
	components: {
		Carousel
	},
    data() {
        return {
            API_BASE,
            result: []
        };
    },
    mounted() {
        window.scrollTo(0, 0);
        axios
            .get(
                `${this.API_BASE}/wp/wp-json/wp/v2/about?per_page=100`
            )
            .then(response => {
                this.result = response.data;
            });
    },
    methods: {
        timelineRight() {
            const slider = this.$refs.slider;
            const mobile = window.innerWidth < 970;
            const scrollDistance = mobile ? slider.offsetWidth : 970;

            if (!mobile && slider.scrollLeft < scrollDistance / 2) {
                slider.scrollLeft = mobile ? slider.offsetWidth / 2 : 600;
            } else {
                slider.scrollLeft += scrollDistance;
            }
        },
        timelineLeft() {
            const slider = this.$refs.slider;
            const mobile = window.innerWidth < 970;
            const scrollDistance = mobile ? slider.offsetWidth : 970;

            slider.scrollLeft -= scrollDistance;
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
    font-weight: normal;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}
</style>



// WEBPACK FOOTER //
// About.vue?35510a4e